export default __webpack_public_path__ + "static/media/user-actions.9546f3b2.svg";